import { render } from "./FormCascader.vue?vue&type=template&id=255dad4f&ts=true"
import script from "./FormCascader.vue?vue&type=script&lang=ts"
export * from "./FormCascader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__